import { render, staticRenderFns } from "./ReportIssueForm.vue?vue&type=template&id=01ee9a2a"
import script from "./ReportIssueForm.vue?vue&type=script&lang=js"
export * from "./ReportIssueForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports